import { forwardRef } from "react";
import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";
import { cn } from "@/lib/utils";

const BrutalRadioGroup = forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Root>
>(({ className, ...props }, ref) => (
  <RadioGroupPrimitive.Root
    className={cn("grid gap-3", className)}
    {...props}
    ref={ref}
  />
));

BrutalRadioGroup.displayName = "BrutalRadioGroup";

const BrutalRadioGroupItem = forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item>
>(({ className, ...props }, ref) => (
  <RadioGroupPrimitive.Item
    ref={ref}
    className={cn(
      "h-6 w-6 border-[3px] border-dark bg-card text-dark focus:outline-none focus:ring-4 focus:ring-primary disabled:cursor-not-allowed disabled:opacity-50",
      className
    )}
    {...props}
  >
    <RadioGroupPrimitive.Indicator className="flex items-center justify-center">
      <div className="h-3 w-3 bg-dark" />
    </RadioGroupPrimitive.Indicator>
  </RadioGroupPrimitive.Item>
));

BrutalRadioGroupItem.displayName = "BrutalRadioGroupItem";

export { BrutalRadioGroup, BrutalRadioGroupItem };
